// 递归数据
// import {websock} from "./socket";
// let allGetInfo=[];
import {createWebSocket} from '../../assets/js/socket'
import server from '../../../public/server/server'
let wsurl=server.IM

function foreachData(data, dateStr, timeStr) {
    if (typeof data === 'object') {
        for (let i in data) {
            if (i.indexOf('Time') !== -1) {
                formatDate(data[i], dateStr, timeStr)  // 转时间戳
            }

            if (typeof data === 'object') {
                foreachData(data[i], dateStr, timeStr)  // 继续递归
            }
        }
    }
}

Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

function formatDate(times, pattern) {
    var d = new Date(times).Format("yyyy-MM-dd hh:mm:ss");
    if (pattern) {
        d = new Date(times).Format(pattern);
    }
    return d.toLocaleString();
}

//获取当前路由
function getCurPath() {
    let path = location.hash;
    if (!path || path.length === 0) {
        path = location.pathname;
    } else {
        path = path.replace('#', '');
    }
    return path.split('?')[0];
}

//按钮权限
function getCanButton(userAuth, btnCode){
    const btnList = this.getListButtons(userAuth);
    const path = this.getCurPath();
    let button = btnList.find(btn => btn.url === path);
    if (!button) {
        button = btnList.find(btn => btn.url.startsWith(path));
    }
    return button && button.buttons.find(btn => btn.englishTag === btnCode);
}

//按钮列表
function getListButtons(userAuth){
    let buttonList=[];
    userAuth.forEach(item => {
        if (item.children.length > 0) {//二级菜单
            item.children.forEach(childItem=>{
                if(item.children.length > 0){
                    if(childItem.children.length>0){
                        childItem.children.forEach(childItem2=>{
                            buttonList.push({
                                url: childItem2.resourceUrl,
                                buttons: childItem2.listButton
                            })
                        })
                    }else {
                        buttonList.push({
                            url: childItem.resourceUrl,
                            buttons: childItem.listButton
                        })
                    }
                }else {
                    buttonList.push({
                        url: childItem.resourceUrl,
                        buttons: childItem.listButton
                    })
                }
            })
        }else{//一级菜单
            buttonList.push({
                url: item.resourceUrl,
                buttons: item.listButton
            })
        }
    })
    return buttonList;
}

function uuidGenerator() {
    let originStr = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
        originChar = '0123456789abcdef',
        len = originChar.length;
    return originStr.replace(/x/g, function () {
        return originChar.charAt(Math.floor(Math.random() * len))
    })
}

function sendMsg(data) {
	if(!sessionStorage.getItem('userId')){
		return false;
	}
    let userId = sessionStorage.getItem('userId').replace(" ",'');
    let message = new proto.Model();
    let content = new proto.MessageBody();
    message.setVersion("1.0")//版本号
    message.setDeviceid("1.0")//设备号
    message.setCmd(Number(data.cmd))//请求接口命令字  1绑定  2心跳   3上线   4下线 5 消息 6 重连 7 群通知 8;//客户端收到消息确认 9：消息已读确认
    message.setSender(userId)//发送人
    if (data.receiver) {
        message.setReceiver(String(data.receiver))//接收人
    }
    if (!data.groupId) {
        message.setGroupid("3d7b69fd-50c3-4e49-a6b8-c2bdc0e46042");//系统用户组
    } else {
        message.setGroupid(String(data.groupId))
    }
    if (data.flag) {
        message.setFlag(data.flag)
        message.setSign(data.sign) //签名
    } // 1 rsa加密 2aes加密
    message.setPlatform('_PC');//用户端
    message.setTimestamp(new Date().getTime());
    message.setToken(uuidGenerator());//token
    if (data.msgtype) {
        message.setMsgtype(Number(data.msgtype));//请求1，应答2，通知3，响应4  format
    }
    if (data.cmd === 5) {
        message.setCheckid(data.checkid);//客户端校验id\
    }
    if (data.msgId) {
        message.setMsgid(data.msgId);//消息ID\
    }
    //内容
    if (data.content && data.content.content) {
        content.setContent(data.content.content); //发送内容
    }

    content.setTime(new Date().getTime())//发送内容时间

    content.setType(0)//0 文字   1 文件
    if(data.content && data.content.type) {
        content.setType(data.content.type)
    }

    if(data.content&&data.content.userId){
        content.setUserid(data.content.userId);//成员id
    }
    if (data.content && data.content.groupType) {
        content.setGrouptype(data.content.groupType);//解散 1，加入2，移除3，已读4
    }
    content.setTitle(data.content && data.content.title ? data.content.title : '')//标题
    message.setContent(content.serializeBinary());
    if(window.websock.readyState===1){
        window.websock.send(message.serializeBinary());
    }else{}

}

function filtrateCodeName(code,val){
     let codeData=JSON.parse(localStorage.getItem('codeData'))
      let item= []
      codeData[code].forEach(ietm=>{if(ietm.itemValue==val){
            item.push(ietm)
      }});
     return item[0].itemName
}
/**
 * 三分位数字
 * str转换的字符串
 * delimiter分隔符号
 * num间隔几位
 */
function formatNum(str, delimiter, num){
  var regex = new RegExp("\\d(?=(\\d{" + num + "})+(?=\\b))", "g");
  return str.replace(regex, "$&" + delimiter);
}
//按钮权限
function checkButton(code){
	let buttonList=JSON.parse(localStorage.getItem('ur')).currentAuthSourceTreeDTOList;
	let result=buttonList.find(item=>item.code===code);
	return result;
}

// 自动播放
function speckText(str) {
    let url = 'https://tts.baidu.com/text2audio?lan=zh&ctp=1&cuid=abcd&ie=UTF-8&vol=9&per=0&spd=5&pit=5&aue=3&tex=' + encodeURI(str);
    let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    // var url = "http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&text=" + encodeURI(str);        // baidu
    // var url = "http://translate.google.cn/translate_tts?ie=UTF-8&tl=zh-CN&total=1&idx=0&textlen=19&prev=input&q=" + encodeURI(str); // google
    if (!isChrome) {
        var n = new Audio(url);
        n.src = url;
        n.play();
    } else {
         window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext ||
             window.msAudioContext;
         try {
             var context = new window.AudioContext();;
             var source = null;
             var audioBuffer = null;
             function playSound() {
                 source = context.createBufferSource();
                 source.buffer = audioBuffer;
                 source.loop = false;
                 source.connect(context.destination);
                 source.start(0); //立即播放
             }
 
             function initSound(arrayBuffer) {
                 context.decodeAudioData(arrayBuffer, function (buffer) { //解码成功时的回调函数
                     audioBuffer = buffer;
                     playSound();
                 }, function (e) { //解码出错时的回调函数
                     console.log('Error decoding file', e);
                 });
             }
 
             function loadAudioFile(url) {
                 var xhr = new XMLHttpRequest(); //通过XHR下载音频文件
                 xhr.open('GET', url, true);
                 xhr.responseType = 'arraybuffer';
                 xhr.onload = function (e) { //下载完成
                     initSound(this.response);
                 };
                 xhr.send();
             }
             loadAudioFile(url);
         } catch (e) {
             console.log('!Your browser does not support AudioContext');
         }
    }
}
const PublicFn = {
    foreachData,
    formatDate,
    getCurPath,
    getCanButton,
    getListButtons,
    uuidGenerator,
    sendMsg,
    filtrateCodeName,
	formatNum,
	checkButton,
	speckText
};
export default PublicFn;
